<div id="loginActivation" class="loginactivation-container ya-typography">
  <ya-subheader class="ya-header-title-wrapper" [hasContent]="true">
    <h2 class="ya-header-title" langkey="phLoginActivation_Title"></h2>
  </ya-subheader>
  <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
    <section class="login-activation-content">
      <div class="login-activation-content-wrapper">
        <div class="content-title">
          <h2><span langkey="phLoginActivation_TitleMessage"></span></h2>
        </div>
        <div class="content-message">
          <span>{{loginActivationMainMessage}}</span>
        </div>
        <div class="content-resent-active-link">
          <a ngClass="ya-caption" (click)="resendLoginActivateRequest()">
            <span langkey="phLoginActivation_ResetPassword"></span>
          </a>
          <!-- <button mat-button [ngClass]="['mat-button','ya-caption']" (click)="resendLoginActivateRequest()">
            <span langkey="phLoginActivation_ResetPassword"></span>
          </button> -->
        </div>
        <div *ngIf="userActivationInvalid" class="login-failed ya-caption">
          <span>{{loginActivationFailedMessage}}</span>
        </div>
        <div class="ya-button-container">
          <button mat-flat-button (click)="loginAvtivation()">
            <span langkey="phLoginActivation_Continue"></span>
          </button>
        </div>
      </div>
    </section>
  </div>
</div>